export enum ProcessFlowMappedVariableType {
  Variable = 1,
  Formula = 2,
  Constant = 3,
}

export const ProcessFlowMappedVariableTypes = [
  ProcessFlowMappedVariableType.Variable,
  ProcessFlowMappedVariableType.Formula,
  ProcessFlowMappedVariableType.Constant,
] as const;

// subset of ProcessFlowMappedVariableTypes
export const ProcessFlowMappedVariableTypesAttachments = [
  ProcessFlowMappedVariableType.Variable,
  // TODO: Uncomment when file picker is added for constant
  // ProcessFlowMappedVariableType.Constant,
] as const

export const ProcessFlowMappedVariableTypesObjects = [
  ProcessFlowMappedVariableType.Variable,
] as const

// for form checkboxes and object model multi select pick lists
export const ProcessFlowMappedVariableTypesPickList = [
  ProcessFlowMappedVariableType.Variable,
  ProcessFlowMappedVariableType.Constant,
] as const

// for text collections like process flow variable text type as collection or repeatable text field
export const ProcessFlowMappedVariableTypesTextCollection = [
  ProcessFlowMappedVariableType.Variable,
] as const

export const ProcessFlowMappedVariableTypesBoolean = [
  ProcessFlowMappedVariableType.Variable,
  ProcessFlowMappedVariableType.Constant,
]

export const ProcessFlowMappedVariableTypesBooleanCollection = [
  ProcessFlowMappedVariableType.Variable,
]

export const ProcessFlowMappedVariableIcons = {
  [ProcessFlowMappedVariableType.Variable]: 'var',
  [ProcessFlowMappedVariableType.Formula]: 'florin',
  [ProcessFlowMappedVariableType.Constant]: 'constant',
} as const

export const ProcessFlowMappedVariableTypesSignature = [
  ProcessFlowMappedVariableType.Variable,
]
